import React from 'react';
import { Card } from './ui/Card';
import { Eye, Filter } from 'lucide-react';
import { AnimatedNumber } from './AnimatedNumber';
import { motion } from 'framer-motion';
interface ObservationsData {
  lifeThreading: number;
  major: number;
  moderate: number;
  minor: number;
  resolved: number;
}
interface ObservationsCardProps {
  data: ObservationsData;
  isFiltered?: boolean;
}
export function ObservationsCard({
  data,
  isFiltered
}: ObservationsCardProps) {
  const total = data.lifeThreading + data.major + data.moderate + data.minor + data.resolved;
  return <Card className="h-full flex flex-col" data-id="element-1021">
      <div className="flex justify-between items-start mb-4" data-id="element-1022">
        <div className="flex items-center gap-2 flex-wrap" data-id="element-1023">
          <div data-id="element-1024">
            <h3 className="font-bold text-gray-900 text-sm mb-1" data-id="element-1025">
              Open Observations
            </h3>
            <p className="text-xs text-gray-500" data-id="element-1026">Last 7 weeks</p>
          </div>
          {isFiltered && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex items-center gap-1 bg-amber-100 text-amber-700 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-1027">
              <Filter size={10} data-id="element-1028" />
              Filtered
            </motion.div>}
        </div>
        <button className="flex items-center gap-1.5 text-xs font-medium text-gray-600 border border-gray-200 rounded px-2.5 py-1 hover:bg-gray-50 transition-colors" data-id="element-1029">
          <Eye size={14} data-id="element-1030" />
          View all
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center" data-id="element-1031">
        <div className="relative w-40 h-40" data-id="element-1032">
          {/* Donut Chart Placeholder */}
          <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-1033">
            <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" strokeWidth="12" data-id="element-1034" />
            <circle cx="50" cy="50" r="40" fill="none" stroke="#fbbf24" strokeWidth="12" strokeDasharray="251.2" strokeDashoffset="0" data-id="element-1035" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1036">
            <AnimatedNumber value={total} className="text-4xl font-bold text-gray-900" data-id="element-1037" />
            <span className="text-xs text-gray-500" data-id="element-1038">Total</span>
          </div>
        </div>
      </div>

      <div className="space-y-2 mt-4" data-id="element-1039">
        <div className="flex items-center justify-between text-sm" data-id="element-1040">
          <div className="flex items-center gap-2" data-id="element-1041">
            <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-1042" />
            <span className="text-gray-700" data-id="element-1043">Life threading</span>
          </div>
          <AnimatedNumber value={data.lifeThreading} className="font-semibold" data-id="element-1044" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-1045">
          <div className="flex items-center gap-2" data-id="element-1046">
            <div className="w-3 h-3 bg-orange-500 rounded-full" data-id="element-1047" />
            <span className="text-gray-700" data-id="element-1048">Major</span>
          </div>
          <AnimatedNumber value={data.major} className="font-semibold" data-id="element-1049" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-1050">
          <div className="flex items-center gap-2" data-id="element-1051">
            <div className="w-3 h-3 bg-amber-500 rounded-full" data-id="element-1052" />
            <span className="text-gray-700" data-id="element-1053">Moderate</span>
          </div>
          <AnimatedNumber value={data.moderate} className="font-semibold" data-id="element-1054" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-1055">
          <div className="flex items-center gap-2" data-id="element-1056">
            <div className="w-3 h-3 bg-gray-400 rounded-full" data-id="element-1057" />
            <span className="text-gray-700" data-id="element-1058">Minor</span>
          </div>
          <AnimatedNumber value={data.minor} className="font-semibold" data-id="element-1059" />
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-1060">
          <div className="flex items-center gap-2" data-id="element-1061">
            <div className="w-3 h-3 bg-emerald-500 rounded-full" data-id="element-1062" />
            <span className="text-gray-700" data-id="element-1063">Resolved (last 2 weeks)</span>
          </div>
          <AnimatedNumber value={data.resolved} className="font-semibold" data-id="element-1064" />
        </div>
      </div>
    </Card>;
}